import axiosInstance from './axiosClient';

const FatafatDollarAPI = {
    // Get all Fatafat Dollar games
    getAllFatafatDollarGames: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiFatafatDollarGames';
        console.log('🔵 API Call - Get Games:');
        console.log('URL:', url);
        console.log('Payload:', payload);
        try {
            const response = await axiosInstance.post(url, payload);
            console.log('✅ API Response:', response.data);
            return {
                status: 'success',
                res: response.data
            }
        } catch (error: any) {
            console.error('❌ API Error:', error);
            console.error('Error details:', error.response?.data || error.message);
            return {
                status: 'failed',
                res: []
            }         
        }
    },

    // Get Fatafat Dollar game rates
    getFatafatDollarGameRates: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiFatafatDollarGameRates';
        try {
            const response = await axiosInstance.post(url, payload);           
            return {
                status: 'success',
                res: response.data
            }
        } catch (error) {
            return {
                status: 'failed',
                res: []
            }          
        }
    },

    // Get Fatafat Dollar game types
    getFatafatDollarGameTypes: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiFatafatDollarGameTypes';
        console.log('🔵 API Call - Get Game Types:');
        console.log('URL:', url);
        console.log('Payload:', payload);
        try {
            const response = await axiosInstance.post(url, payload);
            console.log('✅ API Response - Game Types:', response.data);
            console.log('Game Types Count:', response.data?.game_types?.length || 0);
            console.log('Game Types Array:', response.data?.game_types);
            return {
                status: 'success',
                res: response.data
            }
        } catch (error: any) {
            console.error('❌ API Error - Game Types:', error);
            console.error('Error details:', error.response?.data || error.message);
            return {
                status: 'failed',
                res: []
            }          
        }
    },

    // Check Fatafat Dollar game status
    checkFatafatDollarGameStatus: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiCheckFatafatDollarGameStatus';
        try {
            const response = await axiosInstance.post(url, payload);            
            return {
                status: 'success',
                res: response.data
            }
        } catch (error) {
            return {
                status: 'failed',
                res: []
            }          
        }
    },

    // Submit Fatafat Dollar bid
    submitFatafatDollarBid: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiFatafatDollarSubmitBid';
        try {
            const response = await axiosInstance.post(url, payload);           
            return {
                status: 'success',
                res: response.data
            }
        } catch (error) {
            return {
                status: 'failed',
                res: []
            }          
        }
    },

    // Get Fatafat Dollar bid history
    getFatafatDollarBidHistory: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiFatafatDollarBidHistory';
        try {
            const response = await axiosInstance.post(url, payload);          
            return {
                status: 'success',
                res: response.data
            }
        } catch (error) {
            return {
                status: 'failed',
                res: []
            }           
        }
    },

    // Get Fatafat Dollar winning history
    getFatafatDollarWinningHistory: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiFatafatDollarWinningHistory';
        try {
            const response = await axiosInstance.post(url, payload);          
            return {
                status: 'success',
                res: response.data
            }
        } catch (error) {
            return {
                status: 'failed',
                res: []
            }           
        }
    },

    // Get Fatafat Dollar results
    getFatafatDollarResults: async (payload: any) => {
        const url = '/Fatafatdollarapicontroller/apiFatafatDollarResults';
        try {
            const response = await axiosInstance.post(url, payload);          
            return {
                status: 'success',
                res: response.data
            }
        } catch (error) {
            return {
                status: 'failed',
                res: []
            }           
        }
    },
}

export default FatafatDollarAPI;

